var map = {
	"./audio-placeholder": 344,
	"./audio-placeholder.png": 344,
	"./avatar-missing": 206,
	"./avatar-missing.png": 206,
	"./avatar-missing.svg": 671,
	"./header-missing": 270,
	"./header-missing.png": 270,
	"./soapbox-logo": 271,
	"./soapbox-logo-white": 272,
	"./soapbox-logo-white.svg": 272,
	"./soapbox-logo.svg": 271,
	"./video-placeholder": 345,
	"./video-placeholder.png": 345,
	"./void": 346,
	"./void.png": 346,
	"./web-push/web-push-icon_expand": 378,
	"./web-push/web-push-icon_expand.png": 378,
	"./web-push/web-push-icon_favourite": 379,
	"./web-push/web-push-icon_favourite.png": 379,
	"./web-push/web-push-icon_reblog": 380,
	"./web-push/web-push-icon_reblog.png": 380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670;